module.exports = __webpack_public_path__ + "img/TetrisMenu.21192d58.png";